// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyModel {
    static getAttributeTypeMap() {
        return PharmacyModel.attributeTypeMap;
    }
}
PharmacyModel.discriminator = undefined;
PharmacyModel.additionalProperties = false;
PharmacyModel.attributeTypeMap = [
    {
        "name": "pharmacyId",
        "baseName": "pharmacyId",
        "type": "number"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "nabp",
        "baseName": "nabp",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "pharmacyType",
        "baseName": "pharmacyType",
        "type": "PharmacyType"
    },
    {
        "name": "pharmacySpecialization",
        "baseName": "pharmacySpecialization",
        "type": "PharmacySpecialization"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": ""
    },
];
//# sourceMappingURL=pharmacyModel.js.map